export default {
    message: 'Message',
    primary: 'Notification',
    info: 'Info',
    success: 'Success',
    warning: 'Warning',
    danger: 'Error',
};



// WEBPACK FOOTER //
// ./resources/js/components/enso/bulma/toastr/config/titles.js